import React, { PureComponent } from 'react';
import {
	Wrapper,
	Link,
	StarIcon,
} from './marketingCtaStyles';
import { HeaderCta } from 'core/components/Header/headerConstants';

class MarketingCta extends PureComponent {
	render () {
		return (
			<Wrapper>
				<Link href={`${HeaderCta['link']}`}>
					<StarIcon />
					{`${HeaderCta['copy']}`}
				</Link>
			</Wrapper>
		);
	}
}

export default MarketingCta;
